import { CancelJobSubmissionAction } from './CancelJobSubmissionAction';
import { CancelJobSubmissionSuccessAction } from './CancelJobSubmissionSuccessAction';
import { AdvancedFilterAction } from './AdvancedFilterAction';
import { AdvancedFilterSuccessAction } from './AdvancedFilterSuccessAction';

export type Actions = CancelJobSubmissionAction |
                      CancelJobSubmissionSuccessAction |
                      AdvancedFilterAction |
                      AdvancedFilterSuccessAction;

export * from './CancelJobSubmissionAction';
export * from './CancelJobSubmissionSuccessAction';
export * from './AdvancedFilterAction';
export * from './AdvancedFilterSuccessAction';



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/index.ts